export const operators = {
  field: {
    url: 'URL',
    id: 'ID',
    type: 'type',
    login: 'Login',
    pass: 'Password',
    campaigns_name: 'Campaigns',
    weight: 'Operator weight ',
    status: 'Status',
    wrtc: 'WRTC',
    instance: 'Server',
    created_at: 'Created at'
  },

  button: {
    create: 'Create operators',
    disabled: 'All webhooks are already created'
  },

  modal: {
    create: 'Create operator',
    edit: 'Edit operator',
    remove: {
      content: 'Are you sure you want to delete the operator {type}?'
    },
    change_status: {
      enable: 'Are you sure you want to activate the operator?',
      disable: 'Are you sure you want to deactivate the operator?'
    }
  },
  tooltip: {
    delete: 'Delete operator skill'
  },
  error: {
    create_project: 'Failed to create product',
    unique_create_project: 'The product with this name already exists',
    create_skill: 'Failed to create skill',
    edit_skill: 'Failed to change skill'
  },
  skills: {
    title: 'Operator skills',
    add: '+ Add operator skill',
    product: 'Product',
    weight: 'Skill weight',
    create: 'Create product',
    edit: 'Edit product',
    name: 'Product name'
  }
};
